import { c as createToastInstance, a as closeById, b as closeAllNotifications } from "../toast-1e0d9ebf.mjs";
import { d as defineVuesticPlugin } from "../../../services/vue-plugin/utils/define-vuestic-plugin-8c565dfe.mjs";
import { d as defineGlobalProperty } from "../../../services/vue-plugin/utils/global-properties-9524ee5b.mjs";
const createVaToastPlugin = (app) => ({
  /** Returns toast instance id */
  init(options) {
    return createToastInstance(options, app == null ? void 0 : app._context);
  },
  close(id) {
    closeById(id);
  },
  closeAll(allApps = false) {
    closeAllNotifications(allApps ? void 0 : app == null ? void 0 : app._context);
  }
});
const VaToastPlugin = defineVuesticPlugin(() => ({
  install(app) {
    defineGlobalProperty(app, "$vaToast", createVaToastPlugin(app));
  }
}));
export {
  VaToastPlugin as V
};
//# sourceMappingURL=index-aa9f5dff.mjs.map
